<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

<div class="container pt-5">
  <div class="row justify-content-start">
    <div class="col-12">
      <div class="text-lg-start mb-4">
        <h3 class="mb-3 font-weight-normal">{{mode === 'update' ? 'Update Member' : mode === 'view' ? 'View Member' :
          'Add Member'}}</h3>
      </div>
      <main class="form-signin border p-4 rounded">
        <form [formGroup]="addMemberForm" (ngSubmit)="submit()">
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="form-floating">
                <select formControlName="clientId" id="clientId" class="form-control"
                  [class.is-invalid]="submitted && addMemberForm.get('clientId')?.errors">
                  <option value="" disabled selected>Select a Client</option>
                  <option *ngFor="let client of masterCommonService.clientsList" [value]="client.id">{{
                    client.companyName }}</option>
                </select>
                <label for="clientId">Client</label>
                <span class="text-danger"
                  *ngIf="submitted && addMemberForm.get('clientId')?.hasError('required')">Client is required</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-floating">
                <input formControlName="memberName" id="memberName" type="text" placeholder="Member Name"
                  class="form-control" [class.is-invalid]="submitted && addMemberForm.get('memberName')?.errors">
                <label for="memberName">Member Name</label>
                <span class="text-danger"
                  *ngIf="submitted && addMemberForm.get('memberName')?.hasError('required')">Member Name is
                  required</span>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="form-floating">
                <input formControlName="email" id="email" type="email" placeholder="Email" class="form-control"
                  [class.is-invalid]="submitted && addMemberForm.get('email')?.errors">
                <label for="email">Email</label>
                <span class="text-danger" *ngIf="submitted && addMemberForm.get('email')?.hasError('required')">Email is
                  required</span>
                <span class="text-danger" *ngIf="submitted && addMemberForm.get('email')?.hasError('email')">Email is
                  invalid</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-floating">
                <input formControlName="mobile" id="mobile" type="text" placeholder="Mobile" class="form-control"
                  [class.is-invalid]="submitted && addMemberForm.get('mobile')?.errors">
                <label for="mobile">Mobile</label>
                <span class="text-danger" *ngIf="submitted && addMemberForm.get('mobile')?.hasError('required')">Mobile
                  is required</span>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="form-floating">
                <input formControlName="skypeId" id="skypeId" type="text" placeholder="Skype ID" class="form-control">
                <label for="skypeId">Skype ID</label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-floating">
                <input formControlName="telephone" id="telephone" type="text" placeholder="Telephone"
                  class="form-control">
                <label for="telephone">Telephone</label>
              </div>
            </div>
          </div>
          <div class="form-check mb-3">
            <input formControlName="isWhatsApp" id="isWhatsApp" type="checkbox" class="form-check-input">
            <label for="isWhatsApp" class="form-check-label">Is WhatsApp</label>
          </div>
          <div *ngIf="mode !== 'view'" class="d-grid mt-4 px-1">
            <button class="btn btn-lg btn-info" type="submit" [disabled]="isSubmitDisabled || addMemberForm.invalid">{{mode === 'update' ? 'Update Member' : 'Add
              Member'}}</button>
          </div>
        </form>
      </main>
    </div>
  </div>
</div>